module.exports = __webpack_public_path__ + "static/media/Aditya Naik.414d8cf5.jpg";